(() => {
  function enhancePolicy() {
    const container = document.querySelector('.shopify-policy__container');
    const title = container?.querySelector('.shopify-policy__title h1');
    const body = container?.querySelector('.shopify-policy__body');
    const template = document.getElementById('PPNativePolicyLayout');
    if (!container || !title || !body || !template) return;
    const fragment = template.content.cloneNode(true);
    const page = fragment.querySelector('pp-policy-page');
    if (!page) return;
    // Move the original nodes: preserve legal copy, IDs, links and embedded content.
    page.querySelector('.pp-policy-header').append(title);
    const content = page.querySelector('.pp-policy-content');
    while (body.firstChild) content.append(body.firstChild);
    if (container.id) page.id = container.id;
    container.replaceWith(fragment);
    template.remove();
    // Restore a direct section anchor after the contents have moved.
    if (location.hash) {
      try {
        const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
        if (target && page.contains(target)) requestAnimationFrame(() => target.scrollIntoView());
      } catch (_) { /* Keep the page readable even with an invalid URL fragment. */ }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhancePolicy, { once: true });
  else enhancePolicy();
})();
